import { api } from '@/lib/api';
import { quotationService } from './quotation.service';
import { approveExpense, rejectExpense } from './expense.service';
import { updatePRStatus } from './purchase.service';
import { postJournalEntry } from './journalEntry.service';

export type PendingApprovalType = 'Quotation' | 'Expense' | 'PurchaseRequest' | 'SupplierInvoice' | 'JournalEntry';

export interface PendingApproval {
  id: string;
  module: string;
  type: PendingApprovalType;
  typeLabel: string;
  no: string;
  title: string;
  amount: number;
  date: string;
  requestedByName: string;
  detailUrl?: string;
}

// SupplierInvoice has no reject flow on the backend (SupplierInvoiceController only exposes
// /approve) — Draft invoices are corrected by editing them, not rejected. JournalEntry is the
// same: a Draft manual JE can only be Posted or left as Draft, there's no "reject" concept.
export const canReject = (type: PendingApprovalType) => type !== 'SupplierInvoice' && type !== 'JournalEntry';

export const approvalService = {
  async getPending(): Promise<PendingApproval[]> {
    const res = await api.get<PendingApproval[]>('/approvals/pending');
    return res.data ?? [];
  },

  approve(item: PendingApproval) {
    switch (item.type) {
      case 'Quotation': return quotationService.approve(item.id);
      case 'Expense': return approveExpense(item.id);
      case 'PurchaseRequest': return updatePRStatus(item.id, 'Approved');
      case 'SupplierInvoice': return api.post(`/supplier-invoices/${item.id}/approve`, {});
      case 'JournalEntry': return postJournalEntry(item.id);
    }
  },

  reject(item: PendingApproval) {
    switch (item.type) {
      case 'Quotation': return quotationService.reject(item.id);
      case 'Expense': return rejectExpense(item.id);
      case 'PurchaseRequest': return updatePRStatus(item.id, 'Rejected');
      case 'SupplierInvoice': throw new Error('Bill tidak memiliki alur tolak.');
      case 'JournalEntry': throw new Error('Journal Entry tidak memiliki alur tolak.');
    }
  },
};
